import React, {Component} from 'react';
import {Col, Image, Row} from 'react-bootstrap';
import { getAccessToken } from "../../utils/auth";

class CustomFolder extends Component {

    componentDidMount() {
        this.populate_image_with_src();
    }

    populate_image_with_src = async () => {
        let accessToken = await getAccessToken()
        for (let i = 0; i < this.props.resources.length ; i++) {
            const resource = this.props.resources[i];
            if (resource.id_imagemaker) {
                return fetch(global.config.server_path + `imagemaker/history/${resource.id_imagemaker}`, 
                    {
                        method: 'GET',
                        headers: {'Content-Type':'application/json', 'Authorization': accessToken}
                    }
                )
                .then(data => data.json())
                .then(({data}) => {
                    var element = document.getElementById("resource_"+resource.id_imagemaker);
                    if (element) {
                        element.src= data.images[0].imageUrl;
                    }
                })
            }else if (resource.id_123rf) {
                fetch(global.config.server_path+'design_resource/load_123rf_resource/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resource.id_123rf})})
                .then(data => data.json())
                .then(data => {
                    var element = document.getElementById("resource_"+resource.id_123rf);
                    if (element) {
                        const img_src = (data.data.src.indexOf('data:image')>-1 || data.data.src.indexOf('http')>-1 || data.data.src.indexOf('blob:')>-1)?data.data.src:global.config.server_path+ data.data.src
                        element.src= img_src;
                    }
                })
            }else if (resource.id_123rf_plus) {
                fetch(global.config.server_path+'design_resource/load_123rf_plus_resource/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resource.id_123rf_plus})})
                .then(data => data.json())
                .then(data => {
                    var element = document.getElementById("resource_"+resource.id_123rf_plus);
                    if (element) {
                        const img_src = (data.data.src.indexOf('data:image')>-1 || data.data.src.indexOf('http')>-1 || data.data.src.indexOf('blob:')>-1)?data.data.src:global.config.server_path+ data.data.src
                        element.src= img_src;
                    }
                })
            }else if (resource.id_pixlr) {
                fetch(global.config.server_path+'design_resource/load_pixlr_resource/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resource.id_pixlr})})
                .then(data => data.json())
                .then(data => {
                    var element = document.getElementById("resource_"+resource.id_pixlr);
                    if (element) {
                        const img_src = (data.data.src.indexOf('data:image')>-1 || data.data.src.indexOf('http')>-1 || data.data.src.indexOf('blob:')>-1)?data.data.src:global.config.server_path+ data.data.src
                        element.src= img_src;
                    }
                })
            }else if (resource.id_design_resource) {
                fetch(global.config.server_path+'design_resource/load_design_resource/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resource.id_design_resource})})
                .then(data => {
                    document.getElementById("resource_"+resource.id_design_resource).src= global.config.static_file_server_path + data.data.src;
                })
            }
            else {
                document.getElementById("resource_"+resource.path).src = global.config.static_file_server_path + resource.path;
            }
        }
    }

    generate_folder_view = () => {
        return (
            <div style={{'paddingTop': '30px'}}>
               <span style={{'fontSize': '2.8rem', 'fontWeight': '700'}}>{this.props.name}</span>
                <Row style={{paddingTop : 15}}>
                    {
                        this.props.resources.map(x => <Image id={"resource_"+(x.id_imagemaker?x.id_imagemaker:(x.id_123rf?x.id_123rf:(x.id_123rf_plus?x.id_123rf_plus:(x.id_pixlr?x.id_pixlr:(x.id_design_resource?x.id_design_resource:x.path)))))} src="" height={300}/>)
                    }
                </Row>
            </div>
        )
    }

    generate_panel_view = () => {
        return (
            <div>
                <div onClick={this.props.back_button_on_click}>
                    <span style={{marginLeft: 12, marginBottom: 4, 'fontSize': '1.2rem', 'fontWeight': '600', 'float': 'Left',cursor: "pointer"}}>
                        Back
                    </span>
                    <br />
                </div>
                <Row>
                    {
                        this.props.resources.map(x => <Col xs={6}><Image onClick={() => {this.props.on_click(x)}} id={"resource_"+(x.id_imagemaker?x.id_imagemaker:(x.id_123rf?x.id_123rf:(x.id_123rf_plus?x.id_123rf_plus:(x.id_pixlr?x.id_pixlr:(x.id_design_resource?x.id_design_resource:x.path)))))} src="" width={150}/></Col>)
                    }
                </Row>
            </div>
        )
    }

    render() {
        if (!this.props.resources) return (<div></div>)
        if (this.props.view_type && this.props.view_type=="panel_view") {
            return (
                <div>
                    {this.generate_panel_view()}
                </div>
            )
        }
        return (
            <div>
                {this.generate_folder_view()}
            </div>
        )
    }
}

export default CustomFolder;
